
export class ColumnSorter
{

    constructor(definitions = []) {
        this.definitions = [...definitions];
    }

    getSortedColumns() {
        return this.definitions
            .sort((column1, column2) => this.getColumnSortOrder(column1) - this.getColumnSortOrder(column2));
    }

    getOrderOf(column) {
        return {
            undefined: -100,
            firstName: -99,
            lastName: -98,
            email: -97,
            gradYear: -96,
            jerseyNumber: -95
        }[column];
    }

    getColumnSortOrder(column) {
        if (this.getOrderOf(column.name) !== undefined)
            return this.getOrderOf(column.name);

        if (column.required)
            return -1;

        return 0;
    }
}